var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37271 4.10881C1.73615 3.89208 2.20755 4.00921 2.42562 4.37041L5.11831 8.83059H18.8817L21.5744 4.37041C21.7924 4.00921 22.2638 3.89208 22.6273 4.10881C22.9907 4.32553 23.1086 4.79403 22.8905 5.15523L20.186 9.63506V16.9661C20.186 18.0894 19.2697 19 18.1395 19H5.86053C4.73028 19 3.81404 18.0894 3.81404 16.9661V9.63506L1.10948 5.15523C0.891415 4.79403 1.00927 4.32553 1.37271 4.10881ZM6.11634 15.9492C6.11634 16.3704 6.45993 16.7119 6.88377 16.7119H9.95351C10.3774 16.7119 10.7209 16.3704 10.7209 15.9492C10.7209 15.5279 10.3774 15.1865 9.95351 15.1865H6.88377C6.45993 15.1865 6.11634 15.5279 6.11634 15.9492Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpen);
export default __webpack_public_path__ + "static/media/box-open.caadf0b23c8108eea0a55f4d24797caa.svg";
export { ForwardRef as ReactComponent };